import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/system'

import { SPACES } from 'src/constants'

const useStyles = makeStyles((theme: Theme) => ({
  buttonsWrapper: {
    marginBottom: SPACES.xxl,

    display: 'flex',
    gap: SPACES.l,
    flexWrap: 'wrap',
  },
  buttonWrapper: {},
}))

export { useStyles }
